import PropTypes from 'prop-types';

import { ITEM_TYPES } from '@/common/constants';
import {
  BaseDefaultProps,
  BasePropTypes,
} from '@/common/proptypes/Base/Base.proptypes';

export const WorksiteDefaultProps = {
  ...BaseDefaultProps,
  entity: {},
  onSuccess: () => null,
};

export const WorksitePropTypes = {
  ...BasePropTypes,
  entity: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    worksite: PropTypes.oneOfType([
      PropTypes.shape({
        code: PropTypes.string,
        label: PropTypes.string,
      }),
      PropTypes.arrayOf(PropTypes.shape({})),
    ]),
  }),
  onSuccess: PropTypes.func,
  type: PropTypes.oneOf([
    ITEM_TYPES.quote,
    ITEM_TYPES.cart,
    ITEM_TYPES.order,
    ITEM_TYPES.draft,
    ITEM_TYPES.installer,
  ]).isRequired,
};
